<div class="container-lg container-xl cornerr bg-white py-2 my-2">
    <div class="container">
    <div id="glit" class="container">
        <h1 class="imgBW">Cabildo de Nuevo Laredo</h1>
        <div id="line"></div>
    </div>
    
    <div class="row">
        <!-- Tarjeta ejemplo -->
   
   
<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/s1.jpg" alt="Foto de Jesús Alberto Jasso Montemayor">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/s1.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">JESÚS ALBERTO JASSO MONTEMAYOR</h4>
            <h6 class="card-category text-gray">Síndico No. 1</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/s2.jpg" alt="Foto de María Mirna Rendón Santos">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/s2.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">MARÍA MIRNA RENDÓN SANTOS</h4>
            <h6 class="card-category text-gray">Síndico No. 2</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/1.jpeg" alt="Foto de Sergio Fernando Pérez Villareal">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/1.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">SERGIO FERNANDO PÉREZ VILLAREAL</h4>
            <h6 class="card-category text-gray">Regidor No. 1</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/2.jpg" alt="Foto de Samantha Khiabett Rodriguez Cantu">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/2.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">SAMANTHA KHIABETT RODRIGUEZ CANTU</h4>
            <h6 class="card-category text-gray">Regidor No. 2</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/3.jpg" alt="Foto de Juan de Dios Juanes Carrizalez">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/3.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">JUAN DE DIOS JUANES CARRIZALEZ</h4>
            <h6 class="card-category text-gray">Regidor No. 3</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/4.jpg" alt="Foto de Roxana Lozano Madrigan">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/4.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">ROXANA LOZANO MADRIGAL</h4>
            <h6 class="card-category text-gray">Regidor No. 4</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/5.jpg" alt="Foto de Jose Guadalupe Zapata Muñiz">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/5.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">JOSE GUADALUPE ZAPATA MUÑIZ</h4>
            <h6 class="card-category text-gray">Regidor No. 5</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/6.jpg" alt="Foto de Cristabell Zamora Cabrera">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/6.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">CRISTABELL ZAMORA CABRERA</h4>
            <h6 class="card-category text-gray">Regidor No. 6</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/7.jpg" alt="Foto de Enrique Figueroa Rocha" style="max-height: 150px;">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/7.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">ENRIQUE FIGUEROA ROCHA</h4>
            <h6 class="card-category text-gray">Regidor No. 7</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/8.jpg" alt="Foto de Melissa Lizette Riestra Martinez">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/8.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">MELISSA LIZETTE RIESTRA MARTINEZ</h4>
            <h6 class="card-category text-gray">Regidor No. 8</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/9.jpg" alt="Foto de Santos Francisco Hernández Aguilar">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/9.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">SANTOS FRANCISCO HERNÁNDEZ AGUILAR</h4>
            <h6 class="card-category text-gray">Regidor No. 9</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/10.jpeg" alt="Foto de Macarena Corazón Gonzalez Núñez">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/10.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">MACARENA CORAZÓN GONZALEZ NÚÑEZ</h4>
            <h6 class="card-category text-gray">Regidor No. 10</h6>
        </div>
    </div>
</div>
<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/11.jpeg" alt="Foto de Jose Hemin Pascacio Rodríguez">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/11.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">JOSE HEMIN PASCACIO RODRÍGUEZ</h4>
            <h6 class="card-category text-gray">Regidor No. 11</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/12.jpeg" alt="Foto de Alma Margarita Sanchez Lerma">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/12.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">ALMA MARGARITA SÁNCHEZ LERMA</h4>
            <h6 class="card-category text-gray">Regidor No. 12</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/13.jpeg" alt="Foto de Gabriel Alberto Solorzano Pérez">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/13.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">GABRIEL ALBERTO SOLORZANO PÉREZ</h4>
            <h6 class="card-category text-gray">Regidor No. 13</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/14.jpeg" alt="Foto de Leticia Yazmin Meneses Camino">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/14.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">LETICIA YAZMIN MENESES CAMINO</h4>
            <h6 class="card-category text-gray">Regidor No. 14</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/15.jpeg" alt="Foto de Félix Fernando García Aguiar">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/15.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">FÉLIX FERNANDO GARCÍA AGUIAR</h4>
            <h6 class="card-category text-gray">Regidor No. 15</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/16.jpeg" alt="Foto de Leticia Judith Barrera Garza">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/16.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">LETICIA JUDITH BARRERA GARZA</h4>
            <h6 class="card-category text-gray">Regidor No. 16</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/17.jpeg" alt="Foto de Oscar José Treviño Carmona">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/17.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">OSCAR JOSÉ TREVIÑO CARMONA</h4>
            <h6 class="card-category text-gray">Regidor No. 17</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/18.jpeg" alt="Foto de Delia Cortes Benavides" style="max-height: 155px;">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/18.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">DELIA CORTES BENAVIDES</h4>
            <h6 class="card-category text-gray">Regidor No. 18</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/19.jpeg" alt="Foto de Edgardo Pedraza Quintanilla">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/19.jpeg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">EDGARDO PEDRAZA QUINTANILLA</h4>
            <h6 class="card-category text-gray">Regidor No. 19</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/20.jpg" alt="Foto de Alma Rosa Castaño Rodríguez">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/20.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">ALMA ROSA CASTAÑO RODRÍGUEZ</h4>
            <h6 class="card-category text-gray">Regidor No. 20</h6>
        </div>
    </div>
</div>

<div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="card card-profile ">
        <div class="card-header card-header-image">
            <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/21.jpg" alt="Foto de Gamaliel Alberto Infante Ramírez">
            <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/21.jpg'); opacity: 1;"></div>
        </div>
        <div class="card-body">
            <h4 class="card-title">GAMALIEL ALBERTO INFANTE RAMÍREZ</h4>
            <h6 class="card-category text-gray">Regidor No. 21</h6>
        </div>
    </div>
</div>


    
        <!-- Repite las demás tarjetas con la misma estructura -->
    </div>
    </div>
</div>




<!--
    <div class="row">
         


            
            <div class="col-12  col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/s2.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/s2.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">MARÍA MIRNA RENDÓN SANTOS</h4>
                        
                        <h6 class="card-category text-gray">Sindico No. 2</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        <img class="img-fluid" src="https://nld.gob.mx/assets/img/cabildo/s2.jpg" alt="Foto de María Mirna Rendón Santos">
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/s2.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body">
                        <h4 class="card-title">MARÍA MIRNA RENDÓN SANTOS</h4>
                        <h6 class="card-category text-gray">Síndico No. 2</h6>
                    </div>
                </div>
            </div>
            <div class="col-12  col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/1.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/1.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">SERGIO FERNANDO PÉREZ VILLAREAL</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 1</h6>
                    </div>
                </div>
            </div>
            
            <div class="col-12  col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/2.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/2.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">SAMANTHA KHIABETT RODRIGUEZ CANTU</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 2</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/3.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/3.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">JUAN DE DIOS JUANES CARRIZALEZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 3</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                                               
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/4.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/4.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">IMAYRA IVETH INOCENCIO GONZALEZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 4</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/5.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/5.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">JOSE GUADALUPE ZAPATA MUÑIZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 5</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/6.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/6.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">CRISTABELL ZAMORA CABRERA</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 6</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/7.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/7.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">ENRIQUE FIGUEROA ROCHA</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 7</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/8.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/8.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">MELISSA LIZETTE RIESTRA MARTINEZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 8</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/9.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/9.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">SANTOS FRANCISCO HERNÁNDEZ AGUILAR</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 9</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/10.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/01.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">MACARENA CORAZÓN GONZALEZ NÚÑEZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 10</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/11.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/11.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">JOSE HEMIN PASCACIO RODRÍGUEZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 11</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/12.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/12.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">ALMA MARGARITA SÁNCHEZ LERMA</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 12</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/13.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/13.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">GABRIEL ALBERTO SOLORZANO PÉREZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 13</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                          <img class="img" src="https://nld.gob.mx/assets/img/cabildo/14.jpeg">
                        

                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/14.jpeg'); opacity: 1;">
                        </div>
                   
                    </div>
                    <div class="card-body ">
                       
                        <h4 class="card-title">LETICIA YAZMIN MENESES CAMINO</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 14</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/15.jpeg">
                            
                        
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/15.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">FÉLIX FERNANDO GARCÍA AGUIAR</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 15</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/16.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/16.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">LETICIA JUDITH BARRERA GARZA</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 16</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/17.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/17.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">OSCAR JOSÉ TREVIÑO CARMONA</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 17</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/18.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/18.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">DELIA CORTES BENAVIDES</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 18</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/19.jpeg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/19.jpeg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">EDGARDO PEDRAZA QUINTANILLA</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 19</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/20.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/20.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">ALMA ROSA CASTAÑO RODRÍGUEZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 20</h6>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 col-lg-3">
                <div class="card card-profile">
                    <div class="card-header card-header-image">
                        
                        
                            <img class="img" src="https://nld.gob.mx/assets/img/cabildo/21.jpg">
                        
                        <div class="colored-shadow" style="background-image: url('https://nld.gob.mx/assets/img/cabildo/21.jpg'); opacity: 1;">
                        </div>
                    </div>
                    <div class="card-body ">
                        <h4 class="card-title">GAMALIEL ALBERTO INFANTE RAMÍREZ</h4>
            
                        <h6 class="card-category text-gray">Regidor No. 21</h6>
                    </div>
                </div>
            </div>
       
        </div>
-->